<!-- Start Sign in Area -->
<div class="sign-in-area ptb-100">
  <div class="container">
    <div class="section-title">
      <h2>Sign in to Your Account!</h2>
    </div>

    <div class="sign-in-form">
      <form>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="email"
            placeholder="Username or Email"
            autocomplete="email"
            #email
            (input)="onUsername($event)"
          />
        </div>

        <div class="form-group">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Password"
            autocomplete="current-password"
            #password
          />
        </div>

        <div class="text-center">
          <ng-container
            *ngIf="this.authFacade.loading$ | async; else submitButton"
          >
            <button type="button" class="btn default-btn-one">
              <mat-spinner [diameter]="24" class="spinner"></mat-spinner>
            </button>
          </ng-container>
          <ng-template #submitButton>
            <button
              type="button"
              class="btn default-btn-one"
              (click)="onSubmit(email, password)"
            >
              Sign In
            </button>
          </ng-template>

          <p class="account-decs" *ngIf="forgotPassword">
            <a (click)="onForgotPassword(email)">Forgot Password?</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- End Sign in  Area -->
